<script lang="ts" setup>
import { useExpenseTemp } from "@/store/expensesTemp";

const expenseTempStore = useExpenseTemp();
const vehicleTypeEnum = computed(() => {
	return expenseTempStore.vehicleTypeEnum;
});
const emit = defineEmits(["change"]);
const props = defineProps<{ ping: number }>();

const errorArr = ref([]);
const items = ref({
	client: null,
	location: null, // ward
	category: null, // grade
	vehicleType: null,

	startDate: null,
	endDate: null,
	engineType: null,
	distance: null,
	travelFrom: null,
	travelTo: null,
});

// const listOfClients = ref(null); // Object
const listOfClients = computed(() => expenseTempStore.clientList);
const location = ref<any>([]); // ward
const subcategory = ref<any>([]); // grade

// new
function formatWard(item, value) {
	setItem(item, value);
	location.value = items.value.client?.locations; // locations arr which references on wards
	subcategory.value = [];
	items.value.category = null;
	items.value.location = null;

	if (location.value?.length === 1) {
		const val = generatFromVal(0);
		inputWard(val);
	}
}

function inputWard(e, manualInput = false) {
	manualInput
		? (items.value.location = e)
		: (items.value.location =
				items.value.client?.locations[Number(e.target.value)]);
	items.value.category = null;
	formatGrade(); // category

	setItem("location", items.value.location);
}

function formatGrade() {
	subcategory.value = items.value.location?.subcategories; // subcategories arr which references on grades
	items.value.category = null;
	if (subcategory.value.length === 1) {
		const val = generatFromVal(0);
		inputGrade(val, false);
	}
}
function inputGrade(e: any, manualInput = false) {
	console.log("e", e);
	manualInput
		? (items.value.category = e)
		: (items.value.category =
				items.value.location?.subcategories[Number(e.target?.value)]);

	// if (manualInput) {
	// 	items.value.category =
	// 		items.value.location?.subcategories[Number(e.target?.value)];
	// }
	//  else {
	// items.value.category = e;
	// }

	setItem("category", items.value.category);
}

function generatFromVal(i) {
	return {
		target: {
			value: i,
		},
	};
}

// end new
const listOfVehicles = computed(() => {
	return [
		vehicleTypeEnum.value.CAR,
		vehicleTypeEnum.value.MOTORCYCLE,
		vehicleTypeEnum.value.BICYCLE,
	];
});
// const listOfEngineTypesCar = ref(null); // Object
const listOfEngineTypesCar = computed(() => {
	const carRange = expenseTempStore.getRanges("EMCR");

	const arr = carRange?.map((item) => {
		item.name = expenseTempStore.getLabelForEngineType(item);
		return item;
	});

	return arr ?? [];
});

// const listOfEngineTypesMotorcycle = ref(null); // Object
const listOfEngineTypesMotorcycle = computed(() => {
	const motorRange = expenseTempStore.getRanges("EMMC");

	const array = motorRange?.map((item) => {
		item.name = expenseTempStore.getLabelForEngineType(item);
		return item;
	});
	return array ?? [];
});

function setItem(item, value) {
	errorArr.value.includes(item) &&
		errorArr.value.splice(errorArr.value.indexOf(item), 1);
	// items.value[item] = value;
	if (item === "vehicleType") {
		items.value.engineType = null;
	}
	console.log(`${item} :`, value);
	emit("change", items.value);
}

const getEngineTypeForVehicleType = computed(() => {
	if (items.value.vehicleType?.id === vehicleTypeEnum.value?.CAR?.id)
		return listOfEngineTypesCar.value;
	if (items.value.vehicleType?.id === vehicleTypeEnum.value?.MOTORCYCLE?.id)
		return listOfEngineTypesMotorcycle.value;
	return [];
});

const canChooseEngineType = computed(() => {
	return (
		items.value.vehicleType &&
		items.value.vehicleType.id !== vehicleTypeEnum.value?.BICYCLE?.id
	);
});

watch(
	() => props.ping,
	() => {
		errorArr.value = expenseTempStore.handleErrorPing(items.value);
	},
);

onMounted(() => {
	// a
});
</script>
<template>
	<div class="exp-form">
		<div class="group">
			<label class="label">Client name*</label>
			<multiselect-form
				v-model="items.client"
				:options="listOfClients"
				label="name"
				placeholder="Choose client"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('client') }"
				@select="formatWard('client', $event)"
			/>
		</div>
		<div class="group">
			<label class="label">Ward*</label>
			<multiselect-form
				v-model="items.location"
				:options="location"
				label="name"
				placeholder="Choose ward"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('location') }"
				@select="inputWard($event, true)"
			/>
		</div>
		<div class="group">
			<label class="label">Grade*</label>
			<multiselect-form
				v-model="items.category"
				:options="subcategory"
				label="name"
				placeholder="Choose grade"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('category') }"
				@select="inputGrade($event, true)"
			/>
		</div>

		<div class="group">
			<label class="label">Vehicle type*</label>
			<multiselect-form
				v-model="items.vehicleType"
				:options="listOfVehicles"
				label="value"
				placeholder="Choose Vehicle"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('vehicleType') }"
				@select="setItem('vehicleType', $event)"
			/>
		</div>

		<div class="group">
			<label class="label">Engine capacity*</label>
			<multiselect-form
				v-model="items.engineType"
				:options="getEngineTypeForVehicleType"
				label="name"
				placeholder="Engine capacity*"
				value-prop="name"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{
					error: errorArr.includes('engineType') && canChooseEngineType,
				}"
				:disabled="!canChooseEngineType"
				@select="setItem('engineType', $event)"
			/>
		</div>
		<div class="group">
			<label class="label">Start date/time of travel*</label>
			<modern-date-picker
				v-model="items.startDate"
				placeholder="Start Date/Time"
				:clearable="false"
				:enable-time-picker="true"
				format="dd/MM/yyyy, HH:mm"
				outputFormatString="YYYY-MM-DD HH:mm:ss"
				:class="{ error: errorArr.includes('startDate') }"
				@update:model-value="setItem('startDate', $event)"
			/>
		</div>
		<!-- <formElement
			@select="setItem('startTime', $event)"
			title="Journey start time*"
			type="time"
			:errored="errorArr.includes('startTime')"
		/> -->

		<div class="group">
			<label class="label">End date/time of travel*</label>
			<modern-date-picker
				v-model="items.endDate"
				placeholder="End Date/Time"
				:clearable="false"
				:enable-time-picker="true"
				format="dd/MM/yyyy, HH:mm"
				outputFormatString="YYYY-MM-DD HH:mm:ss"
				:class="{ error: errorArr.includes('endDate') }"
				@update:model-value="setItem('endDate', $event)"
			/>
		</div>
		<!-- <formElement
			@select="setItem('endTime', $event)"
			title="Journey end time*"
			type="time"
			:errored="errorArr.includes('endTime')"
		/> -->

		<div class="group">
			<modern-input
				v-model="items.distance"
				:bind="{
					placeholder: 'Input number...',
					class: { error: errorArr.includes('distance') },
					type: 'number',
					min: 0,
				}"
				label="Travelled distance* (in km)"
				type="number"
				@change="setItem('distance', $event)"
			></modern-input>
		</div>

		<div class="group">
			<modern-input
				v-model="items.travelFrom"
				label="Travelled from*"
				:bind="{
					placeholder: 'Input text...',
					class: { error: errorArr.includes('travelFrom') },
				}"
				@change="setItem('travelFrom', $event)"
			></modern-input>
		</div>
		<div class="group">
			<modern-input
				v-model="items.travelTo"
				:bind="{
					placeholder: 'Input text...',
					class: { error: errorArr.includes('travelTo') },
				}"
				label="Travelled to*"
				@change="setItem('travelTo', $event)"
			></modern-input>
		</div>
	</div>
</template>
<style lang="scss">
.exp-form {
	label.label {
		color: $label-accent-color;
		font-size: 0.8rem;
		min-width: 100px;
		user-select: none;
	}
	.modern-input {
		padding: 0 !important;
	}
	.error {
		border-color: $error-color !important;
	}
}
</style>
